/* Project Import will be here */
import * as actions from '../actions/login.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    user: {
        loggedIn: false,
        roleId: 0,
        roleName: "",
        firstName: "",
        lastName: "",
        fullName: "",
        userName: "",
        userId: 0,
        userEmail: "",
        userPhoneNumber: "",
        fcmToken: "",
        accessToken: "",        
        claimValue: [],
        loggedOutUserRole:""
    }
};
/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.LOGIN_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    loggedIn: true,
                    firstName: action.firstName,
                    lastName: action.lastName,
                    fullName: action.fullName,
                    userEmail: action.email,
                    userPhoneNumber: action.phoneNumber,
                    accessToken: action.accessToken,
                    userName: action.userName,
                    userId: action.userId,
                    roleId: action.roleId,
                    roleName: action.roleName,                    
                    claimValue: action.claimValue,
                    loggedOutUserRole: action.roleName

                }
            };

        case actions.LOGOUT:
            return  {
                ...state,
                user: {
                    ...state.user,
                    loggedIn: false,
                    roleId: 0,
                    roleName: "",
                    firstName: "",
                    lastName: "",
                    fullName: "",
                    userName: "",
                    userId: 0,
                    userEmail: "",
                    userPhoneNumber: "",
                    fcmToken: "",
                    accessToken: "",        
                    claimValue: [],
                    loggedOutUserRole: state.user.loggedOutUserRole
                }
            };

        default:
            return state;
    }
}